/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import _ from 'lodash';

import SaveDesignModal from '../SaveDesignModal';
import OpenDesignModal from '../OpenDesignModal';
import { constants, actions } from '../../actions/modal';

// import cx from 'classnames';
import './ModalWrapper.scss';

// const log = require('bows')('ModalWrapper');

type PropsType = {
  modalType: string,
};

const MODAL_COMPONENTS = {
  [constants.MODAL_SAVE_DESIGN]: SaveDesignModal,
  [constants.MODAL_OPEN_DESIGN]: OpenDesignModal,
};

// type StateType = {};

// eslint-disable-next-line react/prefer-stateless-function
export class ModalWrapper extends React.Component<PropsType, *> {
  static defaultProps = {};

  // state: StateType; // eslint-disable-line react/sort-comp
  props: PropsType; // eslint-disable-line react/sort-comp

  /*
  constructor(props: PropsType) {
    super(props);
  }
  */

  render() {
    if (!this.props.modalType) return null;

    const BaseModal = _.get(MODAL_COMPONENTS, [this.props.modalType]);
    return (
      <BaseModal
        show
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state: any, props: PropsType): {} {
  return {
    ...props,
    ...state.modals.modalProps,
    modalType: state.modals.modalType,
  };
}

function mapDispatchToProps(dispatch: AppDispatch): {} {
  return {
    onHide: payload => dispatch(actions.hideModal(payload)),
  };
}

const enhancer: Function = compose(
  connect(mapStateToProps, mapDispatchToProps),
  pure,
);

export default enhancer(ModalWrapper);



// WEBPACK FOOTER //
// ./src/components/ModalWrapper/ModalWrapper.js